import { render, staticRenderFns } from "./ShowImg.vue?vue&type=template&id=f6fd0bdc&scoped=true"
import script from "./ShowImg.vue?vue&type=script&lang=js"
export * from "./ShowImg.vue?vue&type=script&lang=js"
import style0 from "./ShowImg.vue?vue&type=style&index=0&id=f6fd0bdc&prod&lang=stylus&scoped=true"
import style1 from "./ShowImg.vue?vue&type=style&index=1&id=f6fd0bdc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fd0bdc",
  null
  
)

export default component.exports